module.exports = "/assets/iphone@2x.png?9rPWJuv";